import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

const KampoPage = () => {
  const handleHomeClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const consultations = [
    {
      title: '慢性的な疲れ・冷え・むくみ',
      icon: 'ri-temp-cold-line',
      color: 'bg-blue-100 text-blue-800'
    },
    {
      title: '不眠・ストレス・自律神経の乱れ',
      icon: 'ri-mental-health-line',
      color: 'bg-purple-100 text-purple-800'
    },
    {
      title: 'アトピー・湿疹・肌のかゆみ',
      icon: 'ri-hand-sanitizer-line',
      color: 'bg-pink-100 text-pink-800'
    },
    {
      title: '生理痛・更年期障害',
      icon: 'ri-heart-pulse-line',
      color: 'bg-rose-100 text-rose-800'
    },
    {
      title: '胃腸の不調や食欲低下',
      icon: 'ri-restaurant-line',
      color: 'bg-orange-100 text-orange-800'
    },
    {
      title: '肌あれ・美容のお悩み',
      icon: 'ri-sparkling-line',
      color: 'bg-yellow-100 text-yellow-800'
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "name": "漢方相談 - 一心堂薬局",
    "description": "一心堂薬局の漢方相談。体質に合わせた漢方薬の調合で、自然の力で体のバランスを整えます。冷え、疲れ、不眠、肌あれ、更年期の不調など、お気軽にご相談ください。",
    "url": `${import.meta.env.VITE_SITE_URL}/kampo`,
    "mainEntity": {
      "@type": "MedicalBusiness",
      "name": "一心堂薬局 漢方相談",
      "description": "体質改善と自然治癒力を大切にする漢方相談"
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white">
      <SEOHead
        title="漢方相談 - からだの声に耳を傾ける | 一心堂薬局"
        description="一心堂薬局の漢方相談。体質に合わせた漢方薬の調合で、自然の力で体のバランスを整えます。冷え、疲れ、不眠、肌あれ、更年期の不調など、お気軽にご相談ください。千葉県香取郡多古町。"
        keywords="漢方相談,体質改善,冷え,自律神経,アトピー,更年期,一心堂薬局,千葉県香取郡,多古町,薬剤師相談,自然治癒力"
        canonicalUrl={`${import.meta.env.VITE_SITE_URL}/kampo`}
        ogTitle="漢方相談 - からだの声に耳を傾ける | 一心堂薬局"
        ogDescription="一心堂薬局の漢方相談。体質に合わせた漢方薬の調合で、自然の力で体のバランスを整えます。"
        ogType="article"
        structuredData={structuredData}
      />

      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50">
        <div className="max-w-md mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <Link to="/" onClick={handleHomeClick} className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center">
                <i className="ri-leaf-fill text-white text-sm"></i>
              </div>
              <span className="font-bold text-green-800" style={{fontFamily: 'Pacifico, serif'}}>
                相談できる薬局 一心堂薬局
              </span>
            </Link>
            <Link to="/" onClick={handleHomeClick} className="w-8 h-8 flex items-center justify-center">
              <i className="ri-close-line text-green-800 text-xl"></i>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="pt-20 pb-8 px-4">
        <div className="max-w-md mx-auto">
          <div className="mb-6">
            <img 
              src="https://public.readdy.ai/ai/img_res/f5175d838a10c552d3c9439a0a9a9d97.jpg"
              alt="漢方相談"
              className="w-full h-48 object-cover rounded-2xl shadow-lg"
            />
          </div>
          <h1 className="text-2xl font-bold text-amber-800 mb-3 text-center">
            からだの声に耳を傾ける
          </h1>
          <p className="text-lg text-amber-600 text-center mb-4">
            一心堂薬局の漢方相談
          </p>
        </div>
      </div>

      {/* Introduction */}
      <div className="px-4 py-8 bg-white">
        <div className="max-w-md mx-auto">
          <div className="bg-amber-50 rounded-2xl p-6 border-l-4 border-amber-600">
            <p className="text-gray-700 leading-relaxed mb-3">
              「冷え」「疲れ」「不眠」「肌あれ」「更年期の不調」など、病院では原因がはっきりしない"なんとなく不調"。
            </p>
            <p className="text-gray-700 leading-relaxed">
              一心堂薬局では、一人ひとりの体質や生活リズムを大切にし、自然の力で整える漢方相談を行っています。
            </p>
          </div>
        </div>
      </div>

      {/* What is Kampo Consultation */}
      <div className="px-4 py-8 bg-amber-50">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-bold text-amber-800 mb-6 text-center">
            一心堂薬局の漢方相談とは
          </h2>
          <div className="space-y-4">
            <div className="bg-white rounded-2xl p-5 shadow-sm">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-heart-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-2">丁寧なヒアリング</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    薬剤師が体質・生活習慣を丁寧にお伺いし、漢方薬・生薬・健康食品などを組み合わせてご提案します。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-sm">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-flask-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-2">厳選されたエキス剤</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    必要に応じて煎じ薬やエキス剤を使用。体質に合わせた最適な形でお届けします。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-sm">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-check-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-2">継続的なフォロー</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    服薬後の経過を見ながら、無理のない改善を目指します。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Common Consultations */}
      <div className="px-4 py-8 bg-white">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-bold text-amber-800 mb-4 text-center">
            よくあるご相談内容
          </h2>
          <p className="text-sm text-gray-600 text-center mb-6">
            このような症状でお悩みの方、お気軽にご相談ください
          </p>
          <div className="grid grid-cols-2 gap-3">
            {consultations.map((item, index) => (
              <div 
                key={index}
                className={`${item.color} py-3 px-4 rounded-xl text-center text-sm font-medium`}
              >
                {item.title}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Consultation Flow */}
      <div className="px-4 py-8 bg-amber-50">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-bold text-amber-800 mb-6 text-center">
            相談の流れ
          </h2>
          <div className="space-y-4">
            <div className="bg-white rounded-2xl p-5 shadow-sm">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-amber-600 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  1
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-1">ご来店またはお電話でご予約</h3>
                  <p className="text-sm text-gray-600">
                    まずはお気軽にご連絡ください
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-sm">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-amber-600 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  2
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-1">体質・症状・生活習慣などのヒアリング</h3>
                  <p className="text-sm text-gray-600">
                    じっくりとお話を伺います
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-sm">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-amber-600 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  3
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-1">体質に合った漢方薬のご提案</h3>
                  <p className="text-sm text-gray-600">
                    あなたに最適な漢方薬をご提案します
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 shadow-sm">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-amber-600 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
                  4
                </div>
                <div>
                  <h3 className="font-semibold text-amber-800 mb-1">服用後の経過フォローと調整</h3>
                  <p className="text-sm text-gray-600">
                    継続的にサポートいたします
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Kampo Philosophy */}
      <div className="px-4 py-8 bg-white">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-bold text-amber-800 mb-6 text-center">
            漢方が目指すもの
          </h2>
          <div className="space-y-4">
            <div className="bg-gradient-to-r from-amber-100 to-amber-50 rounded-2xl p-6">
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-scales-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-amber-800 mb-2">体のバランスを整える</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    症状を抑えるだけでなく、体の"バランス"を整え、根本から改善を目指します。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-green-100 to-green-50 rounded-2xl p-6">
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-leaf-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-green-800 mb-2">自然の力を引き出す</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    自然の力で"からだ本来の治る力"を引き出します。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Herbal Medicine Image */}
      <div className="px-4 py-8 bg-amber-50">
        <div className="max-w-md mx-auto">
          <div className="bg-white rounded-2xl p-4 shadow-sm">
            <img 
              src="https://readdy.ai/api/search-image?query=Traditional%20Chinese%20medicine%20herbs%20and%20ingredients%2C%20wooden%20drawers%20with%20dried%20herbs%2C%20natural%20lighting%2C%20peaceful%20atmosphere%2C%20traditional%20pharmacy%20interior%2C%20realistic%20photography%20style%2C%20warm%20tones%2C%20organized%20herbal%20medicine%20storage&width=375&height=250&seq=kampo-herbs&orientation=landscape"
              alt="漢方薬"
              className="w-full h-48 object-cover rounded-xl mb-4"
            />
            <div className="text-center">
              <a 
                href="tel:0479-70-6065"
                className="inline-flex items-center space-x-2 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-amber-700 transition-colors"
              >
                <i className="ri-phone-line text-lg"></i>
                <span>電話</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Closing Message */}
      <div className="px-4 py-8 bg-white">
        <div className="max-w-md mx-auto">
          <div className="bg-amber-50 rounded-2xl p-6 border-l-4 border-amber-600">
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-heart-line text-amber-600 text-xl"></i>
              </div>
              <div>
                <h3 className="font-bold text-amber-800 mb-3">
                  からだもこころも整える
                </h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  一心堂薬局では、"からだもこころも整える"漢方相談を大切にしています。
                </p>
                <p className="text-gray-700 leading-relaxed">
                  不調が続くときこそ、ゆっくり体の声を聞いてみませんか？
                </p>
              </div>
            </div>
          </div>

          <div className="mt-6 text-center">
            <Link 
              to="/"
              onClick={handleHomeClick}
              className="inline-block bg-blue-600 text-white py-3 px-8 rounded-full font-medium text-sm"
            >
              <i className="ri-home-line mr-2"></i>
              ホームへ
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white border-t border-gray-200 z-50">
        <div className="max-w-md mx-auto">
          <div className="grid grid-cols-5 py-2">
            <Link to="/" onClick={handleHomeClick} className="flex flex-col items-center justify-center py-2 text-gray-400">
              <i className="ri-home-5-line text-lg"></i>
              <span className="text-xs mt-1">ホーム</span>
            </Link>
            <button className="flex flex-col items-center justify-center py-2 text-gray-400">
              <i className="ri-medicine-bottle-line text-lg"></i>
              <span className="text-xs mt-1">調剤</span>
            </button>
            <button className="flex flex-col items-center justify-center py-2 text-blue-600">
              <i className="ri-leaf-fill text-lg"></i>
              <span className="text-xs mt-1">漢方相談</span>
            </button>
            <button className="flex flex-col items-center justify-center py-2 text-gray-400">
              <i className="ri-map-pin-line text-lg"></i>
              <span className="text-xs mt-1">アクセス</span>
            </button>
            <a href="tel:0479-70-6065" className="flex flex-col items-center justify-center py-2 text-gray-400">
              <i className="ri-phone-line text-lg"></i>
              <span className="text-xs mt-1">お問合せ</span>
            </a>
          </div>
        </div>
      </nav>

      <div className="h-20"></div>
    </div>
  );
};

export default KampoPage;
